import { useEffect, useState } from 'react';
import { FiTrendingUp, FiPlayCircle, FiMessageCircle } from 'react-icons/fi';
import api from '../../api/client';
import Estrellas from '../../components/Estrellas';

export default function AdminReportes() {
    const [tab, setTab] = useState('top');
    const [topCursos, setTopCursos] = useState([]);
    const [vistas, setVistas] = useState([]);
    const [comentarios, setComentarios] = useState([]);

    useEffect(() => {
        Promise.all([
            api.get('/admin/reportes/cursos-top'),
            api.get('/admin/reportes/visualizaciones'),
            api.get('/admin/reportes/comentarios')
        ]).then(([t, v, c]) => {
            setTopCursos(t.data.reportes || []);
            setVistas(v.data.reportes || []);
            setComentarios(c.data.comentarios || []);
        });
    }, []);

    return (
        <div>
            <h1 style={{ margin: '0 0 20px', fontSize: 24 }}>Reportes</h1>

            <div className="tabs">
                <button className={tab === 'top' ? 'activa' : ''} onClick={() => setTab('top')}>
                    <FiTrendingUp /> Cursos top
                </button>
                <button className={tab === 'vistas' ? 'activa' : ''} onClick={() => setTab('vistas')}>
                    <FiPlayCircle /> Visualizaciones
                </button>
                <button className={tab === 'comentarios' ? 'activa' : ''} onClick={() => setTab('comentarios')}>
                    <FiMessageCircle /> Comentarios
                </button>
            </div>

            {tab === 'top' && (
                <table className="tabla">
                    <thead>
                        <tr>
                            <th>Curso</th>
                            <th>Profesor</th>
                            <th>Calificacion</th>
                            <th>Total Calif.</th>
                            <th>Inscritos</th>
                            <th>Completados</th>
                        </tr>
                    </thead>
                    <tbody>
                        {topCursos.map(c => (
                            <tr key={c.id}>
                                <td>{c.nombre}</td>
                                <td>{c.profesor || '-'}</td>
                                <td>
                                    <Estrellas valor={Math.round(c.calificacion_promedio)} soloLectura tamano={12} />
                                    {' '}{Number(c.calificacion_promedio).toFixed(1)}
                                </td>
                                <td>{c.total_calificaciones}</td>
                                <td>{c.total_inscritos}</td>
                                <td>{c.completados}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            {tab === 'vistas' && (
                <table className="tabla">
                    <thead>
                        <tr>
                            <th>Curso</th>
                            <th>Total visualizaciones</th>
                            <th>Usuarios unicos</th>
                            <th>Horas totales</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vistas.map(v => (
                            <tr key={v.id}>
                                <td>{v.nombre}</td>
                                <td>{v.total_visualizaciones}</td>
                                <td>{v.usuarios_unicos}</td>
                                <td>{(v.segundos_totales / 3600).toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            {tab === 'comentarios' && (
                <div className="card">
                    {comentarios.map(c => (
                        <div key={c.id} className="comentario">
                            <div>
                                <span className="autor">{c.usuario_nombre} {c.apellido_paterno}</span>
                                <span style={{ marginLeft: 8, color: 'var(--acento)' }}>en {c.curso}</span>
                                <span className="fecha">{new Date(c.fecha_creacion).toLocaleDateString('es-MX')}</span>
                            </div>
                            <Estrellas valor={c.estrellas} soloLectura tamano={12} />
                            <div className="texto">{c.comentario}</div>
                        </div>
                    ))}
                    {comentarios.length === 0 && (
                        <p style={{ color: 'var(--texto-suave)', textAlign: 'center', padding: 20 }}>Sin comentarios aun</p>
                    )}
                </div>
            )}
        </div>
    );
}
